type OneTrustPopupButtonProps = {
  handleClick: () => void
  className?: string
  children: React.ReactNode
}

/**
 * Create Update consent button
 * with default id and class which are handled by OneTrust script.
 *
 * customClassName - custom styles for every server, result of css()
 */
export const OneTrustPopupButton = ({
  handleClick,
  className,
  children,
}: OneTrustPopupButtonProps) => {
  // cannot use NXD Button because we need to pass the ot-sdk class name, and NXD button doesn't accept a className prop
  return (
    <button
      type='button'
      id='ot-sdk-btn'
      data-testid='update-cookie-setting-button'
      className={className || 'ot-sdk-show-settings'}
      suppressHydrationWarning
      onClick={handleClick}
    >
      {children}
    </button>
  )
}
